module.exports = __webpack_public_path__ + "static/media/administration_accounts_manage.89a36a7f.svg";